<div class="appbar-container" [ngClass]="{ 'gradient-depo': true, 'gradient-posta': posta.isActive, 'gradient-not': not.isActive, 'gradient-kimlik': kimlik.isActive }">
  <!-- suite logo -->
  <div class="appbar-master-logo">
    <!-- <img class="appbar-master-logo-image" src="assets/images/logos/suite-curved.svg" alt="Suite Logo" /> -->
  </div>

  <!-- app logos -->
  <div class="appbar-apps-container">
    <a
      routerLink="/depom"
      routerLinkActive="dummyClass"
      #depo="routerLinkActive"
      class="appbar-app"
      [ngClass]="{ 'appbar-app-active': !posta.isActive && !not.isActive && !kimlik.isActive }"
    >
      <img class="appbar-app-image" src="assets/images/logos/depo-curved.svg" alt="Safir Depo Logo" />
      <span class="appbar-app-label">Depo</span>
    </a>
    <a routerLink="/safir-posta" routerLinkActive="appbar-app-active" #posta="routerLinkActive" class="appbar-app">
      <img class="appbar-app-image" src="assets/images/logos/posta-curved.svg" alt="Safir Posta Logo" />
      <span class="appbar-app-label">Posta</span>
    </a>
    <a routerLink="/safir-not" routerLinkActive="appbar-app-active" #not="routerLinkActive" class="appbar-app">
      <img class="appbar-app-image" src="assets/images/logos/not-curved.svg" alt="Safir Not Logo" />
      <span class="appbar-app-label">Not</span>
    </a>
    <!-- <a routerLink="liste" routerLinkActive="appbar-app-active" class="appbar-app">
      <img class="appbar-app-image" src="assets/images/logos/liste-curved.svg" alt="Liste Logo" />
      <span class="appbar-app-label">Liste</span>
    </a>
    <a routerLink="rehber" routerLinkActive="appbar-app-active" class="appbar-app">
      <img class="appbar-app-image" src="assets/images/logos/rehber-curved.svg" alt="Rehber Logo" />
      <span class="appbar-app-label">Rehber</span>
    </a>
    <a routerLink="takvim" routerLinkActive="appbar-app-active" class="appbar-app">
      <img class="appbar-app-image" src="assets/images/logos/takvim-curved.svg" alt="Takvim Logo" />
      <span class="appbar-app-label">Takvim</span>
    </a> -->
    <a routerLink="safir-kimlik" routerLinkActive="appbar-app-active" #kimlik="routerLinkActive" class="appbar-app">
      <img class="appbar-app-image" src="assets/images/logos/kimlik-curved.svg" alt="Safir Kimlik Logo" />
      <span class="appbar-app-label">Kimlik</span>
    </a>
  </div>

  <!-- extra buttons -->
  <div class="appbar-extra">
    <!-- <div class="w-full h-[75px] py-4">
      <img class="appbar-app-image" src="assets/images/suite/icons/other.svg" alt="Diğer" />
      <span class="appbar-app-label">Diğer</span>
    </div> -->
    <a id="helpBtn" routerLink="/yardim-merkezi" routerLinkActive="router-link-active" class="appbar-extra-item">
      <img class="appbar-extra-image" src="assets/images/suite/icons/question.svg" alt="Yardım" />
      <span class="appbar-app-label"> {{ 'HELP' | translate }}</span>
    </a>
  </div>
</div>
